import { useState } from 'react'
import { useAuth } from '@/auth/AuthProvider'
import { useToast } from '@/ui'
import { useAccountIdentity } from './identity'
import { returnToSelf, switchError } from './impersonation'

/** Shown on every page while an admin is signed in as someone else, with the way back. */
export function ImpersonationBanner() {
  const { impersonation } = useAuth()
  if (!impersonation) return null
  return <Bar byEmail={impersonation.byEmail} />
}

function Bar({ byEmail }: { byEmail: string | null }) {
  const { name, email } = useAccountIdentity()
  const { toast } = useToast()
  const [busy, setBusy] = useState(false)
  const back = async () => {
    setBusy(true)
    try {
      await returnToSelf()
    } catch (e) {
      setBusy(false)
      toast(switchError(e), 'error')
    }
  }
  return (
    <div role="status" className="on-dark flex flex-wrap items-center justify-center gap-x-4 gap-y-1 bg-danger px-4 py-1.5 text-center text-[0.6875rem] uppercase tracking-eyebrow text-paper">
      <span>
        Signed in as {name}
        {email && email !== name ? <span className="normal-case tracking-normal"> ({email})</span> : null}
      </span>
      <button type="button" onClick={() => void back()} disabled={busy} className="underline underline-offset-4 hover:text-paper/80 disabled:cursor-wait">
        {busy ? 'Returning…' : `Return to ${byEmail ?? 'your account'}`}
      </button>
    </div>
  )
}
